import type { PropsWithChildren } from 'react';
import type { ChakraProps } from '@chakra-ui/react';
import { Flex, Grid as ChakraGrid } from '@chakra-ui/react';

export const IzimiTableLayout = ({ children }: PropsWithChildren) => children;

const Grid = ({ children, ...chakraProps }: PropsWithChildren<ChakraProps>) => (
  <ChakraGrid
    height='100%'
    minH={0}
    display={{ base: 'revert', lg: 'grid' }}
    templateColumns='1fr auto'
    flex={1}
    minW={0}
    as='main'
    boxShadow='0px 0px 24px rgb(61 56 54 / 8%)'
    zIndex={1}
    {...chakraProps}>
    {children}
  </ChakraGrid>
);

const Table = ({ children }: PropsWithChildren) => (
  <Flex
    as='article'
    direction='column'
    flex={1}
    minH={0}
    minW={0}
    overflow='hidden'
    borderLeftWidth={{ base: 0, lg: 1 }}
    borderLeftColor='neutral100'>
    {children}
  </Flex>
);

IzimiTableLayout.Grid = Grid;
IzimiTableLayout.Table = Table;
